var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactivemerchantcount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.435,
    height: 23.588,
    viewBox: "0 0 20.435 23.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5851",
    "data-name": "Group 5851",
    transform: "translate(1947.935 3495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17987",
    "data-name": "Path 17987",
    d: "M132.15,261.25a2.67,2.67,0,0,1,2.682-2.682h.67a8.706,8.706,0,0,0-3.5-3.2,6.562,6.562,0,0,1-7.4,0,8.439,8.439,0,0,0-4.767,7.6v1.117a1.467,1.467,0,0,0,1.465,1.465h11.372v-.025l1.266-1.738a2.69,2.69,0,0,1-1.788-2.533Z",
    transform: "translate(-2067.769 -3739.664)",
    fill: "#437dea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17988",
    "data-name": "Path 17988",
    d: "M198.924,24.329a5.164,5.164,0,1,0-5.164-5.164,5.161,5.161,0,0,0,5.164,5.164Z",
    transform: "translate(-2138.417 -3509)",
    fill: "#437dea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17989",
    "data-name": "Path 17989",
    d: "M437.17,368.154h-1.986l2.93-4a1.189,1.189,0,0,0,.1-1.217,1.136,1.136,0,0,0-1.043-.621h-4.246a1.167,1.167,0,1,0,0,2.334h1.986l-2.93,3.973a1.189,1.189,0,0,0-.1,1.217,1.136,1.136,0,0,0,1.043.621H437.2a1.166,1.166,0,0,0,1.167-1.167,1.2,1.2,0,0,0-1.192-1.142Z",
    transform: "translate(-2365.862 -3841.875)",
    fill: "#437dea"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivemerchantcount);
export default __webpack_public_path__ + "static/media/inactivemerchantcount.ae286323fbdb08d10dab29e04d72bc3b.svg";
export { ForwardRef as ReactComponent };